import get from "lodash-es/get";
import { typography } from "../styled";
export var getTypography = function(path) {
    return get(typography, path);
};
